import { flow, Instance, types, detach } from 'mobx-state-tree';
import { getBaseStore } from './BaseStore';
import { getEnvironment } from './utils';
import { BlackPoint } from './models/BlackPoint';
import moment from 'moment';
export const BlackPointSearchCriteria = types.model({
  pharmacyId: types.maybeNull(types.number),
  treated: types.maybeNull(types.boolean),
  date: types.maybeNull(types.Date),
});

export const BlackPointStore = types
  .compose(
    getBaseStore<Instance<typeof BlackPoint>, Instance<typeof BlackPoint>>(BlackPoint, 'blackPointId', 'blackPoint'),
    types.model('BlackPointStore', {}),
  )
  .views((self) => ({
    getByIdOrNew(id: number) {
      if (id > 0) {
        return self.datas.get(id.toString());
      } else {
        return {
          blackPointId: 0,
        };
      }
    },
  }))
  .actions((self) => {
    const env = getEnvironment(self);
    const apiFetcher = env.api;

    const updateBlackPointInStore = (blackPoint: Instance<typeof BlackPoint>) => {
      const blackPointModel = BlackPoint.create(blackPoint);
      self.datas.put(blackPointModel);
      return blackPointModel;
    };

    const search = flow(function*(criteria: Instance<typeof BlackPointSearchCriteria>) {
      const result = yield apiFetcher.get('blackpoint', {
        params: criteria,
      });
      //self.datas.forEach((val) => detach(val));
      const resultBlackPoint: Array<Instance<typeof BlackPoint>> = [];
      // @ts-ignore
      result.forEach((node) => {
        const createdBlackPoint = updateBlackPointInStore(node);
        resultBlackPoint.push(createdBlackPoint);
      });
      return resultBlackPoint;
    });

    const stopBPEncoding = flow(function*(semester: any, secretariatId: number) {
      console.log(semester.toLocaleString('fr-BE'));
      console.log(moment(semester).format('YYYY-MM-DD'));
      const result = yield env.api.post('blackpoint/closeBPEncoding/secretariatId/' + secretariatId + '/semesterEndDate/'+moment(semester).format('YYYY-MM-DD'), null);
      if (result !== '' && result != null) {
      } else {
      }
    })

    return { search, stopBPEncoding };
  });

export type BlackPointStoreType = Instance<typeof BlackPointStore>;
